module.exports = __webpack_public_path__ + "img/emiarch-4-sel.8aa46d56.svg";